import { createSlice } from '@reduxjs/toolkit';

import BonusRepository from '../../repositories/Admin/Memberships/BonusRepository';
import { createRestSlice } from '../../utils/RestSlice';

const bonusRestSlice = createRestSlice({
  resource: 'bonus',
  repository: BonusRepository,
  slices: ['createBonus', 'deleteBonus'],
});

const initialState = {
  ...bonusRestSlice.initialState,
};

const bonusSlice = createSlice({
  name: 'bonus',
  initialState,
  reducers: {
    ...bonusRestSlice.reducers,
  },
});

export default bonusSlice.reducer;

export const bonusRestHooks = bonusRestSlice.hooks(bonusSlice, [
  'admin',
  'BonusSlice',
]);
